import React from 'react';
import './Switch.css';

const Switch = ({ label, checked, onChange, icon }) => {
  return (
    <div className="custom-switch">
      {icon && <span className="switch-icon">{icon}</span>}
      <label className="switch">
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="slider round"></span>
      </label>
      {label && <span className="switch-label">{label}</span>}
    </div>
  );
};

export default Switch;